// PrymeBet cookie-consent state + application to the real tracking tools.
//
// Inventory (keep in sync with the Cookie & Tracking Notice):
//   NECESSARY   — first-party login/session + security (e.g. the auth token). Always on.
//   FUNCTIONAL  — first-party preferences (odds format, notifications). Always on.
//   ANALYTICS   — PostHog (product analytics / session replay). Optional, OFF until accepted.
//   ADVERTISING — none currently deployed. Optional category reserved for the future; OFF until accepted.
//
// PostHog is DEFERRED: its library/requests only start when analytics is accepted —
// applyConsent() calls window.__pbInitPostHog (defined in public/index.html) on consent.
// Before consent and after rejection PostHog never loads (zero PostHog network requests).

export const CONSENT_KEY = "pb_cookie_consent";
export const CONSENT_VERSION = 1;
export const OPEN_PREFS_EVENT = "pb:open-cookie-preferences";
export const CONSENT_CHANGED_EVENT = "pb:cookie-consent-changed";

// Global Privacy Control — an opt-out-of-sale/sharing (advertising) browser signal.
export function gpcEnabled() {
  return typeof navigator !== "undefined" && navigator.globalPrivacyControl === true;
}

export function readConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const rec = JSON.parse(raw);
    if (!rec || rec.v !== CONSENT_VERSION) return null;
    return rec;
  } catch {
    return null;
  }
}

// Effective permissions given a stored record. GPC forces advertising off regardless.
export function effective(rec) {
  return {
    analytics: !!(rec && rec.analytics),
    advertising: !!(rec && rec.advertising) && !gpcEnabled(),
  };
}

// Apply a consent record to the actual tools. Today only PostHog (analytics).
// PostHog is DEFERRED: its library/requests only start when analytics is accepted
// (window.__pbInitPostHog, defined in index.html). Before consent and after
// rejection PostHog never initializes — zero PostHog network requests.
export function applyConsent(rec) {
  const eff = effective(rec);
  if (typeof window === "undefined") return;
  if (eff.analytics) {
    if (typeof window.__pbInitPostHog === "function") window.__pbInitPostHog();
    const ph = window.posthog;
    if (ph && typeof ph.opt_in_capturing === "function") { try { ph.opt_in_capturing(); } catch { /* not ready */ } }
  } else {
    // Only touch PostHog if it was already initialized under a prior acceptance.
    const ph = window.__pbPHInited ? window.posthog : null;
    if (ph && typeof ph.opt_out_capturing === "function") { try { ph.opt_out_capturing(); } catch { /* noop */ } }
  }
  // Advertising: no tools deployed yet. When added, gate them here on eff.advertising.
}

export function saveConsent(choice) {
  const rec = {
    v: CONSENT_VERSION,
    analytics: !!choice.analytics,
    advertising: !!choice.advertising,
    gpc: gpcEnabled(),
    ts: new Date().toISOString(),
  };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(rec));
  } catch {
    /* storage unavailable — consent simply won't persist */
  }
  applyConsent(rec);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: rec }));
  }
  return rec;
}

// Open the Cookie Preferences dialog from anywhere (footer links, the notice page, etc.).
export function openCookiePreferences() {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(OPEN_PREFS_EVENT));
}
